"use client";
import React from "react";
import { Box } from "@mui/material";
import Image from "next/image";
import Logo from "../../../assets/salontym_loder.png";
import "./index.css";

export const Loader = () => {
  return (
    <Box
      sx={{
        top: 0,
        left: 0,
        position: "fixed",
        zIndex: 14000,
        height: "100%",
        width: "100%",
        background: "#00000089",
      }}
    >
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          margin: "auto",
          textAlign: "center",
          width: "20%",
        }}
      >
        <Box className="loader-animation"></Box>
        <Image
          src={Logo}
          alt="Logo"
          style={{
            width: "80px",
            paddingBottom: "16px",
            margin: "auto",
            height: "auto",
          }}
          height={200}
          width={200}
          className="loader-image"
          loading="lazy"
        />
      </Box>
    </Box>
  );
};
